<script>

import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import {useSecurityStore} from "@/stores/Security.js"
import {computed, ref, watch} from "vue";
import useSharedMethod from "@/use/SharedMethod.js";
import {useRecruitmentRequestStore} from "@/stores/Request/RecruitmentRequest.js";
import RecruitmentRequestFilter from "@/views/Request/RecruitmentRequest/Components/RecruitmentRequestFilter.vue";
import axios from "axios";
import {storeToRefs} from "pinia";

export default {
    name: "ListingModel",
    components: {RecruitmentRequestFilter},
    props: {
        type: String
    },
    setup(props) {
        const {
            loading,
            total,
            itemsPerPage,
            filter,
            rightDrawer,
        } = useSharedData();

        const {transformFilterValues, formatedDate, getStatusColor} = useSharedMethod();

        const {$router, $i18n} = useTools();

        const recruitmentRequestStore = useRecruitmentRequestStore();
        const securityStore = useSecurityStore();


        const headers = [
            {
                text: "...",
                sortable: false,
                align: "left",
                value: "action",
                width: "2%"
            },
            {
                text: $i18n.t("common.code"),
                align: "left",
                value: "code",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.occupation"),
                align: "left",
                value: "occupationName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("common.date"),
                align: "left",
                value: "postDateTime",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.requesting_agency"),
                align: "left",
                value: "requestingAgencyName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.applicant"),
                align: "left",
                value: "workerLastName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.reason"),
                align: "left",
                value: "reasonName",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.post_number"),
                align: "left",
                value: "postNumber",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.recruitment_date"),
                align: "left",
                value: "expectedDate",
                sortable: true,
                width: "0%"
            },
            {
                text: $i18n.t("recruitment_request.state"),
                align: "left",
                value: "state",
                sortable: true,
                width: "0%"
            },
        ];

        if (props.type === 'REQUEST') {
            headers.push(
                {
                    text: $i18n.t("common.validation"),
                    align: "start",
                    sortable: true,
                    value: "validationStatus.lastState",
                    width: "0%"
                },
                {
                    text: $i18n.t("common.validation_date"),
                    align: "start",
                    sortable: true,
                    value: "validationStatus.lastValidationDate",
                    width: "0%"
                },
                {
                    text: $i18n.t("common.next_validator"),
                    align: "start",
                    sortable: true,
                    value: "validationStatus.nextValidator",
                    width: "0%"
                },
            );
        } else if (props.type === 'DECISION') {
            headers.push(
                {
                    text: $i18n.t("recruitment_request.interview_number"),
                    align: "left",
                    value: "candidateNumber",
                    sortable: true,
                    width: "0%"
                },
                {
                    text: $i18n.t("recruitment_request.accepted_number"),
                    align: "left",
                    value: "acceptedNumber",
                    sortable: true,
                },
            )
        }
        let actions = [];
        if (props.type === 'REQUEST') {
            actions.push(
                {
                    title: $i18n.t("common.to_filter"),
                    icon: 'mdi-filter',
                    color: 'purple',
                    access: () => true,
                    disabled: (item) => item.state === 'CLOSED',
                    func: (item) => {
                        $router.push({name: 'recruitment_requests.filter', params: {id: item.id}});
                    },
                },
                {
                    title: "Lancer Sourcing",
                    icon: 'mdi-clock-start',
                    color: 'cyan',
                    access: (item) => item.state === 'WAITING',
                    disabled: () => false,
                    func: (item) => {
                        $router.push({name: 'recruitment_requests.start_sourcing', params: {id: item.id}});
                    },
                },
                {
                    title: $i18n.t("common.edit"),
                    icon: 'mdi-pencil-box-multiple',
                    color: 'orange',
                    access: (item) => item.updateOption,
                    disabled: (item) => item.state !== 'VALIDATION',
                    func: (item) => {
                        $router.push({name: 'recruitment_requests.edit', params: {id: item.id}});
                    },
                },
                {
                    title: $i18n.t("common.delete"),
                    icon: 'mdi-trash-can',
                    color: 'red',
                    access: (item) => item.deleteOption,
                    disabled: (item) => item.state !== 'VALIDATION',
                    func: (item) => {
                        $router.push({name: 'recruitment_requests.delete', params: {id: item.id}});
                    },
                },
            );
        } else if (props.type === 'DECISION') {
            actions.push(
                {
                    title: $i18n.t('common.lock'),
                    icon: 'mdi-lock',
                    color: 'grey darken-2',
                    access: () => true,
                    disabled: () => false,
                    func: (item) => {
                        $router.push({name: 'recruitment_decisions.lock', params: {id: item.id}})
                    },
                },
                {
                    title: 'Décider',
                    icon: 'mdi-arrow-decision',
                    color: 'deep-orange',
                    access: () => true,
                    disabled: (item) => item.state !== 'EVALUATION',
                    func: (item) => {
                        $router.push({name: 'recruitment_decisions.edit', params: {id: item.id}})
                    },
                },
            )
        }

        actions.push({
                title: $i18n.t("module.edms"),
                icon: 'mdi-folder',
                color: 'amber',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.documents`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("module.template_application"),
                icon: 'mdi-text-box-multiple',
                color: 'teal',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.template_applications`, params: {id: item.id}})
                },
            },)

        const {itemsToBeValidate} = storeToRefs(securityStore);

        const searchParams = ref({
            sortBy: "launchDate",
            descending: true,
            page: 1,
            itemsPerPage: itemsPerPage
        });

        function handleSearch(params) {
            loading.value = true;
            recruitmentRequestStore.setRecruitmentRequests([]);
            total.value = 0;

            filter.value.itemsToBeValidate = itemsToBeValidate.value;
            
            if(props.type === 'DECISION') {
                filter.value.state = 'EVALUATION';
            }

            loading.value = true;
            filter.value.page = params.page - 1;
            filter.value.rowsPerPage = params.itemsPerPage;
            filter.value.sortBy = params.sortBy;
            filter.value.descending = params.descending;

            axios.get('/recruitmentRequests', {params: transformFilterValues(filter.value)}).then((response) => {
                recruitmentRequestStore.setRecruitmentRequests(response.data.elements);
                total.value = response.data.total;
            }).finally(() => {
                loading.value = false;
            });

        }

        function findAll() {
            handleSearch(searchParams.value)
        }

        watch(() => [filter.value, itemsToBeValidate.value], () => {
            searchParams.page = 1;
            findAll();
        }, {deep: true, immediate: true});

        watch(searchParams, (newParams) => {
            handleSearch(newParams);
        }, {deep: true});

        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                filter.value[key] = null;
            });
            itemsToBeValidate.value = false;
        }

        const rootPath = computed(() => {
            if (props.type === 'REQUEST') {
                return 'recruitment_requests';
            } else if (props.type === 'DECISION') {
                return 'recruitment_decisions';
            }
        });

        function view(item) {
            $router.push({name: `${rootPath.value}.view`, params: {id: item.id}});
        }

        return {
            recruitmentRequestStore,
            securityStore,
            headers,
            loading,
            total,
            itemsPerPage,
            filter,
            rightDrawer,
            actions,
            searchParams,
            itemsToBeValidate,
            rootPath,
            findAll,
            view,
            clearFilter,
            formatedDate,
            getStatusColor
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="`${type === 'REQUEST' ? $t('module.recruitment_request') : $t('module.recruitment_decision')}`"
            show-total
            :total="total"
            show-filter
            :filter="filter"
            @clearFilter="clearFilter"
        >
            <template v-slot:filter>
                <RecruitmentRequestFilter v-model="filter"/>
            </template>

            <template v-slot:leftToolbar>
                <v-checkbox
                    v-model="itemsToBeValidate"
                    :label="$t('common.requests_need_validation')"
                    :true-value="true"
                    :false-value="false"
                    class="ml-2"
                    hide-details
                />
            </template>

            <template v-slot:rightToolbar>
                <w-btn-reload
                    :loading="loading"
                    @press="findAll"
                />
                <w-btn-add
                    :show="securityStore.authorities.SAVE_RECRUITMENT_REQUEST"
                    @press="$router.push({ name: 'recruitment_requests.add' })"
                />
            </template>

            <template v-slot:content>
                <w-server-data-table
                    v-model="searchParams"
                    :actions="actions"
                    :headers="headers"
                    :items="recruitmentRequestStore.recruitmentRequests"
                    :loading="loading"
                    :total="total"
                    :show-validation="type === 'REQUEST'"
                    :root-path="rootPath"
                    module="RECRUITMENT_REQUEST"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                    <template v-slot:[`item.occupationName`]="{ item }">
                        <w-inline-text bold :text="item.occupationName"/>
                    </template>
                    <template v-slot:[`item.postDateTime`]="{ item }">
                        <w-inline-text :text="formatedDate(item.postDateTime)"/>
                    </template>
                    <template v-slot:[`item.workerLastName`]="{ item }">
                        <w-inline-text :text="item.workerName"/>
                    </template>
                    <template v-slot:[`item.requestingAgencyName`]="{ item }">
                        <w-inline-text :text="item.requestingAgencyName"/>
                    </template>
                    <template v-slot:[`item.reasonName`]="{ item }">
                        <w-inline-text :text="item.reasonName"/>
                    </template>
                    <template v-slot:[`item.postNumber`]="{ item }">
                        <w-chip outlined :text="item.postNumber"/>
                    </template>
                    <template v-slot:[`item.candidateNumber`]="{ item }">
                        <w-chip outlined :text="item.candidateNumber"/>
                    </template>
                    <template v-slot:[`item.acceptedNumber`]="{ item }">
                        <w-chip outlined :text="item.acceptedNumber"/>
                    </template>
                    <template v-slot:[`item.expectedDate`]="{ item }">
                        <w-chip color="teal" :text="formatedDate(item.expectedDate)"/>
                    </template>
                    <template v-slot:item.state="{ item }">
                        <w-chip :color="getStatusColor(`RECRUITMENT_${item.state}`)" :text="$t(`recruitment_request.${item.state}`)"/>
                    </template>
                </w-server-data-table>
            </template>
        </w-app>

        <router-view/>
    </div>
</template>